export const config = {
    "build_timestamp": "2024-04-18T21:49:34.587Z",
    "geoKey": "AIzaSyBeeIWUhRhc2ZW9oKxUugzu8y9JQgFVcvA",
    "zoomSdkKey": "Egz3OjF7ITKvLvhHxRhxLNa5us9uJQ24oJX7",
    "mockServices": false,
    "env": "specialdh",
    "serverUrl": "https://specialdh.eonlineworkshop.com/dhWebsite",
    "imgUrl": "https://dh.eonlineworkshop.com/",
    "razorAppKey": "rzp_live_yxYVhNWAkRzybF"
};
